import * as R from 'ramda';
import {
    ACTION_MENUS_INIT,
    OPEN_ACTION_MENU,
    CLOSE_ACTION_MENU
} from './constants';

const defaultState = {
    actionMenus: {}
};

const formsManagerTable = (state = defaultState, {type, payload}) => {
    let actionMenus;
    switch(type) {
        case ACTION_MENUS_INIT:
            return R.merge(state, {actionMenus: payload});
        case OPEN_ACTION_MENU:
            const { urlFormId, el } = payload;
            actionMenus = R.assoc(urlFormId, el, state.actionMenus);
            return R.merge(state, {actionMenus});
        case CLOSE_ACTION_MENU:
            actionMenus = R.assoc(payload, null, state.actionMenus);
            return R.merge(state, {actionMenus});
        default:
            return state;
    }
}

export default formsManagerTable;
